import { useCallback } from 'react';
import { OptionKey } from '@common-fe/common-fe';

import { ALL_OPTION_KEY } from '@/common/constants';

const useSelectAllHandler = (values:OptionKey[], onChangeValues: (values: OptionKey[]) => void ) => {

  const handleChangeValues = useCallback(
    (newValues: OptionKey[]) => {
      if (newValues.includes(ALL_OPTION_KEY) && !values.includes(ALL_OPTION_KEY) && values.length) {
        onChangeValues([ALL_OPTION_KEY]);
      } else if (values.includes(ALL_OPTION_KEY) || !values.length) {
        onChangeValues(newValues.filter((item) => item !== ALL_OPTION_KEY));
      } else {
        onChangeValues(newValues);
      }
    },
    [onChangeValues, values]
  );
  return handleChangeValues;
};

export default useSelectAllHandler;